import React, { useEffect, useState } from "react";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

import Head from "@/components/Head/Head";
import MainLayout from "@/components/MainLayout/MainLayout";
import Abbreviations from "@/components/Abbreviations/Abbreviations";
import { clearUnnecessaryPropertiesForBreadcrumbs } from "@/shared/utils/breadcrumbs/breadcrumbs";
import { loadFolder } from "@/shared/server-api/api";
import { MENU_ITEM_LOCATION } from "@/shared/utils/menu";
import { MenuItems, MenuItemsList, MainMenuItem } from "@/utils/MenuItems.constants";
import { getAbbreviationsRequest } from "@/shared/api/content/books/requests";
import { parseHost, parseProtocol } from "@/shared/utils/appServer/appServer";
import { getSSRCommonData } from "../next/utils/ssr/ssr";
import { I18N_NAMESPACE } from "@/shared/utils/multilang/constants";
import { IdsTabs, Tab } from "@/components/Abbreviations/Abbreviations.constants";

const AbbreviationsPage = ({ breadcrumbsProps, pageUrl }) => {
  const [abbreviations, setAbbreviations] = useState({});

  useEffect(() => {
    async function fetchAbbreviations() {
      const fetchedAbbreviations = await getAbbreviationsRequest();
      setAbbreviations(fetchedAbbreviations);
    }

    fetchAbbreviations();
  }, []);

  return (
    <MainLayout breadcrumbs={breadcrumbsProps}>
      <Head pageTitle={breadcrumbsProps.title} url={pageUrl} />

      <Abbreviations abbreviations={abbreviations} />
    </MainLayout>
  );
};

export async function getServerSideProps(context) {
  const {
    localeData: { locale },
    landingData,
    isInvalidLanding,
  } = await getSSRCommonData(context);

  if (isInvalidLanding) {
    return {
      notFound: true,
    };
  }

  const translate = await serverSideTranslations(locale, [I18N_NAMESPACE.common]);
  const { folder } = await loadFolder(locale);
  const homeItems = MenuItemsList.filter(({ locations }) =>
    locations.includes(MENU_ITEM_LOCATION.HOME),
  );

  const typeQuery = context.query.type;
  const type = IdsTabs.includes(typeQuery) ? typeQuery : Tab.EGW;

  const mainCrumb = {
    ...MainMenuItem,
    children: [...folder.children, ...homeItems],
  };

  const abbr = type === Tab.EGW ? MenuItems.bibliographyEgw : MenuItems.bibliographyBible;

  const breadcrumbsProps = {
    title: abbr.label,
    breadcrumbs: clearUnnecessaryPropertiesForBreadcrumbs([mainCrumb, abbr]),
  };

  const host = parseHost(context.req);
  const proto = parseProtocol(context.req, host);
  const urlOriginReq = `${proto}//${host}`;

  return {
    props: {
      breadcrumbsProps,
      urlOrigin: urlOriginReq,
      pageUrl: urlOriginReq + context.req.url,
      ...translate,
      ...landingData,
    },
  };
}

export default AbbreviationsPage;
